import React from "react";
import { Link } from "react-router-dom";

// Inline brand mark: crosshair (precision) + drop (water) + X (expertise)
export function LogoMark({ size = 34, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} aria-hidden>
      <circle cx="24" cy="20" r="13" stroke="#009CFF" strokeWidth="2" />
      <line x1="24" y1="2" x2="24" y2="9" stroke="#009CFF" strokeWidth="2" />
      <line x1="24" y1="31" x2="24" y2="38" stroke="#009CFF" strokeWidth="2" />
      <line x1="6" y1="20" x2="13" y2="20" stroke="#009CFF" strokeWidth="2" />
      <line x1="35" y1="20" x2="42" y2="20" stroke="#009CFF" strokeWidth="2" />
      <path d="M24 13c3 4 5 6.5 5 9.2a5 5 0 0 1-10 0c0-2.7 2-5.2 5-9.2Z" fill="#009CFF" />
    </svg>
  );
}

export default function Logo({ variant = "dark", withTagline = false }) {
  const textColor = variant === "dark" ? "text-white" : "text-ink";
  return (
    <Link to="/" data-testid="logo-link" className="inline-flex items-center gap-2.5 group">
      <LogoMark className="transition-transform duration-500 group-hover:rotate-90" />
      <span className="flex flex-col leading-none">
        <span className={`text-2xl font-extrabold tracking-tight ${textColor}`}>
          Fuite<span className="text-aqua">X</span>
        </span>
        {withTagline && (
          <span className="text-[9px] font-semibold tracking-[0.2em] text-aqua/80 uppercase mt-0.5">
            Localisation précise
          </span>
        )}
      </span>
    </Link>
  );
}
